var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import React from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { autocompletion } from '@codemirror/autocomplete';
import { javascript } from '@codemirror/lang-javascript';
import { Box, Button, Flex, Icon, Select, Text } from '@chakra-ui/react';
import { StoreContext } from '../uistore/Rootstore';
import { Observer, observer } from 'mobx-react';
import { SchemaItemType } from '@@/Schema';
import { FaPlayCircle } from '@react-icons/all-files/fa/FaPlayCircle';
let CustomCodeEditor = class CustomCodeEditor extends React.Component {
    constructor(prop) {
        super(prop);
        this.adjustx = 0;
        this.adjusty = 0;
        this.boxref = null;
        this.coderef = null;
        window.addEventListener("mouseup", () => {
            this.props.state.setDragging(false);
        });
        window.addEventListener("mousemove", (e) => {
            if (this.props.state.dragging) {
                // lets move this dialog 
                this.props.state.setToppos(e.clientY - this.adjusty);
                this.props.state.setLeftPos(e.clientX - this.adjustx);
            }
        });
        window.addEventListener("touchmove", (e) => {
            if (this.props.state.dragging) {
                // lets move this dialog 
                this.props.state.setToppos(e.touches[0].clientY - this.adjusty);
                this.props.state.setLeftPos(e.touches[0].clientX - this.adjustx);
            }
        });
        window.addEventListener("touchend", () => {
            this.props.state.setDragging(false);
        });
    }
    onChange(value) {
        this.props.state.setContent(value);
    }
    render() {
        var _a, _b;
        if (!this.props.state.show) {
            return React.createElement(React.Fragment, null);
        }
        const rstore = this.context;
        let shs = [];
        let sitems = [];
        if (this.props.state.selectedid) {
            const ans = rstore.mainSchemaStore.anasschema.get(this.props.state.selectedid);
            if (ans) {
                ans.forEach((an) => an.schemaopen && shs.push(an.schemaopen));
            }
        }
        if (this.props.state.selectesid) {
            const sh = rstore.mainSchemaStore.anas.get(this.props.state.selectesid);
            if (sh && sh.schemaopen) {
                let fsitems = sh.schemaopen.items;
                for (const si of fsitems) {
                    if (si.type === SchemaItemType.List) {
                        const lite = si;
                        for (const lii of lite.items) {
                            sitems.push(Object.assign(Object.assign({}, lii.item), { id: si.id + "----" + lii.id, name: si.name + "!" + lii.item.name }));
                        }
                    }
                    else {
                        sitems.push(si);
                    }
                }
            }
        }
        return React.createElement(Box, { "code-box-drag": 'codebox', ref: (ref) => this.boxref = ref, bg: 'white', borderRadius: '2px', borderWidth: '1px', borderColor: 'transparent', boxShadow: '0px 0px 4px 4px #c5c4c4', zIndex: 400, cursor: this.props.state.dragging ? 'grabbing' : '', onMouseDown: (e) => {
                var _a, _b;
                const tgt = e.target;
                if (tgt.getAttribute("code-box-drag")) {
                    this.props.state.setDragging(true);
                    if (this.boxref) {
                        this.adjustx = e.clientX - ((_a = this.boxref) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left);
                        this.adjusty = e.clientY - ((_b = this.boxref) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top);
                    }
                }
            }, onTouchStart: (e) => {
                var _a, _b;
                const tgt = e.target;
                if (tgt.getAttribute("code-box-drag")) {
                    this.props.state.setDragging(true);
                    if (this.boxref) {
                        this.adjustx = e.touches[0].clientX - ((_a = this.boxref) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left);
                        this.adjusty = e.touches[0].clientY - ((_b = this.boxref) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top);
                    }
                }
            }, position: 'fixed', left: this.props.state.leftposition + "px", top: this.props.state.topposition + "px", minW: this.props.state.width + "px", height: this.props.state.height + "px" },
            React.createElement(Flex, { "code-box-drag": 'codebox', align: 'flex-start', w: '100%', h: '70px', bg: 'lightgray' },
                !this.props.hiderunbtn && React.createElement(Button, { leftIcon: React.createElement(Icon, { as: FaPlayCircle }), onClick: () => {
                        this.props.run(this.props.state.text);
                    } }, "Run"),
                React.createElement(Button, { ml: '5px', onClick: () => {
                        this.props.state.setShow(false);
                        this.props.done(this.props.state.text);
                    } }, "Done"),
                React.createElement(Box, { ml: '5px' },
                    React.createElement(Observer, null, () => React.createElement(Select, { size: 'sm', placeholder: 'Select Datasheet', value: this.props.state.selectedid, onChange: (e) => {
                            this.props.state.setDatasheetId(e.currentTarget.value);
                        } }, Array.from(rstore.datasheetStore.schemas.values()).map(dt => React.createElement("option", { key: dt.id, value: dt.id }, dt.name)))),
                    React.createElement(Text, { mt: '4px' }, this.props.state.selectedid)),
                this.props.state.selectedid !== '' && React.createElement(Box, { ml: '5px' },
                    React.createElement(Observer, null, () => React.createElement(Select, { size: 'sm', placeholder: 'Select Worksheet', value: this.props.state.selectesid, onChange: (e) => {
                            this.props.state.setSchemaId(e.currentTarget.value);
                        }, w: '200px', ml: '5px' }, shs.map((dt) => React.createElement("option", { key: dt.id, value: dt.id }, dt.name)))),
                    React.createElement(Text, { mt: '4px' }, this.props.state.selectesid + " (" + ((_b = (_a = rstore.mainSchemaStore.schemas.get(this.props.state.selectesid)) === null || _a === void 0 ? void 0 : _a.apicode) !== null && _b !== void 0 ? _b : '') + ")")),
                this.props.state.selectesid !== '' && React.createElement(Box, { ml: '5px' },
                    React.createElement(Observer, null, () => React.createElement(Select, { size: 'sm', placeholder: 'Select Column', value: this.props.state.selectecid, onChange: (e) => {
                            const myitem = sitems.filter((ite) => ite.id === e.currentTarget.value);
                            if (myitem.length > 0 && myitem[0].type === SchemaItemType.Choice) {
                                this.props.state.addChoiceItems(myitem[0].items);
                            }
                            else {
                                this.props.state.addChoiceItems([]);
                            }
                            this.props.state.setColumnId(e.currentTarget.value);
                        }, w: '200px', ml: '5px' }, sitems
                        .map((dt) => React.createElement("option", { key: dt.id, value: dt.id }, dt.name)))),
                    React.createElement(Text, { mt: '4px' }, this.props.state.selectecid)),
                this.props.state.choicitems.length > 0 && React.createElement(Box, { ml: '5px' },
                    React.createElement(Observer, null, () => React.createElement(Select, { size: 'sm', placeholder: 'Select Item', value: this.props.state.selectechid, onChange: (e) => {
                            this.props.state.setColumnChoiceId(e.currentTarget.value);
                        }, w: '200px', ml: '5px' }, this.props.state.choicitems
                        .map((dt) => React.createElement("option", { key: dt.id, value: dt.id }, dt.name)))),
                    React.createElement(Text, { mt: '4px' }, this.props.state.selectechid))),
            React.createElement(CodeMirror, { "code-box-drag": 'codebox', ref: (ref) => {
                    this.coderef = ref;
                }, value: this.props.state.text, height: (this.props.state.height - 70) + "px", width: this.props.state.width + "px", basicSetup: {
                    autocompletion: true,
                    syntaxHighlighting: true,
                    history: true,
                    historyKeymap: true,
                    completionKeymap: true,
                }, extensions: [javascript({ jsx: true, }), autocompletion({ activateOnTyping: true })], onChange: (val, up) => {
                    this.onChange(val);
                } }));
    }
};
CustomCodeEditor.contextType = StoreContext;
CustomCodeEditor = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], CustomCodeEditor);
export { CustomCodeEditor };
